// extracted by mini-css-extract-plugin
export var container = "pagination-module--container--f2711";
export var controls = "pagination-module--controls--398eb";
export var pageDropdown = "pagination-module--pageDropdown--e25c5";
export var row = "pagination-module--row--a3176";